export var ADVANCED_PRODUCT = {
  AdvancedMySqlDataBase: 'mySqlDatabase',
  AdvancedDcsMemcached: 'dcsMemcached',
  AdvancedDmsRabbitMq: 'dmsRabbitMq',
  AdvancedDcsRedis: 'dcsRedis',
  AdvancesDmsKafka: 'dmsKafka',
  AdvancedMapReduce: 'mapReduce',
  AdvancedDataLakeInsight: 'dataLakeInsight',
  AdvancedDataAsYouUse: 'dataAsYouUse',
  AdvancedServerlessFunctions: 'functionGraph',
  AdvancedObjectStorage: 'objectStorage',
  AdvancedElasticsearch: 'cloudSearchService',
  AdvancedDataWarehouseService: 'dataWarehouseService',
  AdvancedScalableFile: 'scalableFile',
  AdvancedCloudBackup: 'cloudBackup',
  AdvancedCloudContainerEngine: 'cloudContainerEngine',
  AdvancedElasticLoadBalance: 'elasticLoadBalance',
  AdvancedSqlDatabase: 'sqlDatabase',
  AdvancedPostgreSqlDatabase: 'postgreSqlDatabase',
  AdvancedDocumentDatabase: 'documentDatabase',
  AdvancedCloudServer: 'cloudServer',
  AdvancedNetwork: 'network'
};